// extracted by mini-css-extract-plugin
export default {"container":"ProgressBar_container__UQyOG","progress":"ProgressBar_progress__Zw4Af"};